const IconizedIcon = (props) => (
	<svg 
		xmlns="http://www.w3.org/2000/svg" 
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props} 
	>
		<circle cx="7" cy="7" r="4" strokeWidth="2"/>
	</svg>
)

export default IconizedIcon